<div class="header-container" [ngClass]="'justify-content-between'">
  <div class="header-content">
    <div class="w-100"></div>
  </div>
  <div>
    <app-header-elements></app-header-elements>
  </div>
</div>
